import { ChannelAddMessageReaction, ChannelAddMessageReactionResponse } from "../../proto/ChannelAddMessageReaction_pb";
import { RoomMessageReaction } from "../../proto/Global_pb";
import store from "../../store";
import { editRoomMessage } from "../../store/messages/actions";
import BaseHandler from "../BaseHandler";

export default class HandleChannelAddMessageReactionResponse extends BaseHandler<ChannelAddMessageReactionResponse, ChannelAddMessageReaction> {
  handle() {
    const channelAddMessageReactionResponse = this.response.toObject();
    const channelAddMessageReactionRequest = this.request?.toObject();

    if (channelAddMessageReactionRequest !== undefined) {
      let message = store.getState().messages.messages[channelAddMessageReactionRequest.messageId];
      if (message?.channelExtra !== undefined) {
        store.dispatch(
          editRoomMessage({
            messageId: channelAddMessageReactionRequest.messageId,
            message: {
              channelExtra: {
                ...message.channelExtra,
                thumbsUpLabel:
                  channelAddMessageReactionRequest.reaction === RoomMessageReaction.THUMBS_UP ? channelAddMessageReactionResponse.reactionCounterLabel : message.channelExtra.thumbsUpLabel,
                thumbsDownLabel:
                  channelAddMessageReactionRequest.reaction === RoomMessageReaction.THUMBS_DOWN ? channelAddMessageReactionResponse.reactionCounterLabel : message.channelExtra.thumbsDownLabel,
              },
            },
          })
        );
      }
    }
  }
}
